import i18n from '../i18n'
export const REPLY = 'reply'
export const NOTE = 'note'

export const channelTypes = [
    {
        label: 'chat:settings.channels.add.types.email',
        value: 1,
        subheading: 'chat:settings.channels.add.types.emailDesc'
    },
    {
        label: 'chat:settings.channels.add.types.chat',
        value: 2,
        subheading: 'chat:settings.channels.add.types.chatDesc'
    },
    {
        label: 'chat:settings.channels.add.types.facebook',
        value: 3,
        subheading: 'chat:settings.channels.add.types.facebookDesc',
        tier: 'facebookInboxChannel'
        // beta: 'facebook_messenger'
    }
    // {
    //   label: "SMS",
    //   value: 4,
    // },
    // {
    //   label: "WhatsApp",
    //   value: 5,
    // },
]

export function parseChannelType(value) {
    const channel = channelTypes.find((t) => t.value === value)

    if (channel) return i18n.t(channel.label)

    return null
}

export const aiProviders = [
    { label: 'Document360', value: 'document360' },
    { label: 'Freshdesk', value: 'freshdesk' },
    { label: 'Helpscout', value: 'helpscout' },
    { label: 'Intercom', value: 'intercom' },
    { label: 'Stonly', value: 'stonly' },
    { label: 'Zendesk', value: 'zendesk' },
    { label: 'Wordpress Blog', value: 'wordpressBlog' },
    { label: 'WooCommerce', value: 'woocommerce' },
    { label: 'Magento', value: 'magento' },
    { label: 'Helpjuice', value: 'helpjuice' },
    { label: 'Obsidian', value: 'obsidian' },
    { label: 'Text.com', value: 'text.com' },
    { label: 'Other', value: 'manual' }
]

export function getAiProviderLabel(value) {
    const found = aiProviders.find((provider) => provider.value === value)
    if (found) return found.label
    if (!value) return ''
    return value.charAt(0).toUpperCase() + value.slice(1)
}

export function formatAiProviderLabels(providers = []) {
    const labels = providers.map(getAiProviderLabel).filter(Boolean)
    if (labels.length <= 1) return labels[0] || ''
    if (labels.length === 2) return `${labels[0]} and ${labels[1]}`
    return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
}

export const inboxTabOptions = [
    {
        label: 'chat:settings.nav.general',
        value: 'general',
        subheading: 'chat:settings.nav.generalDesc'
    },
    {
        label: 'chat:settings.nav.channels',
        value: 'channels',
        subheading: 'chat:settings.nav.channelsDesc'
    },
    {
        label: 'chat:settings.nav.ai',
        value: 'ai-assistants',
        subheading: 'chat:settings.nav.aiDesc'
    },
    {
        label: 'chat:settings.nav.agents',
        value: 'agents',
        subheading: 'chat:settings.nav.agentsDesc'
    },
    {
        label: 'chat:settings.nav.replies',
        value: 'templates',
        subheading: 'chat:settings.nav.repliesDesc'
    },
    {
        label: 'chat:settings.nav.fields',
        value: 'fields',
        subheading: 'chat:settings.nav.fieldsDesc'
    },
    {
        label: 'chat:settings.nav.sentiment',
        value: 'sentiment',
        subheading: 'chat:settings.nav.sentimentDesc',
        beta: 'sentimentAnalysis'
    }
]

export const emailChannelTabOptions = [
    {
        label: 'chat:channel.email.nav.general',
        value: 'general',
        subheading: 'chat:channel.email.nav.generalDesc'
    },
    {
        label: 'chat:channel.email.nav.forwarding',
        value: 'forwarding',
        subheading: 'chat:channel.email.nav.forwardingDesc'
    },
    {
        label: 'chat:channel.email.nav.signature',
        value: 'signature',
        subheading: 'chat:channel.email.nav.signatureDesc'
    }
]

export const webchatChannelTabOptions = [
    {
        label: 'chat:channel.chat.nav.general',
        value: 'general',
        subheading: 'chat:channel.chat.nav.generalDesc'
    },
    {
        label: 'chat:channel.chat.nav.websites',
        value: 'websites',
        subheading: 'chat:channel.chat.nav.websitesDesc'
    },
    {
        label: 'chat:channel.chat.nav.design',
        value: 'design',
        subheading: 'chat:channel.chat.nav.designDesc',
        view: 'split'
    },
    {
        label: 'chat:channel.chat.nav.visibility',
        value: 'visibility',
        subheading: 'chat:channel.chat.nav.visibilityDesc'
    },
    {
        label: 'chat:channel.chat.nav.availability',
        value: 'agent-availability',
        subheading: 'chat:channel.chat.nav.availabilityDesc'
    },
    {
        label: 'chat:channel.chat.nav.availabilityMessages',
        value: 'availability-messages',
        subheading: 'chat:channel.chat.nav.availabilityMessagesDesc'
    },
    {
        label: 'chat:channel.chat.nav.welcomeMessages',
        value: 'welcome-messages',
        subheading: 'chat:channel.chat.nav.welcomeMessagesDesc'
    },
    {
        label: 'chat:channel.chat.nav.prompts',
        value: 'prompts',
        subheading: 'chat:channel.chat.nav.promptsDesc'
    }
]

export const facebookMessengerChannelTabOptions = [
    {
        label: 'chat:channel.facebook.nav.general',
        value: 'general',
        subheading: 'chat:channel.facebook.nav.generalDesc'
    },
    {
        label: 'chat:channel.facebook.nav.welcome',
        value: 'welcome-messages',
        subheading: 'chat:channel.facebook.nav.welcomeDesc'
    },
    {
        label: 'chat:channel.chat.nav.availability',
        value: 'agent-availability',
        subheading: 'chat:channel.chat.nav.availabilityDesc'
    },
    {
        label: 'chat:channel.chat.nav.availabilityMessages',
        value: 'availability-messages',
        subheading: 'chat:channel.chat.nav.availabilityMessagesDesc'
    }
]

export const aiAssistantTabOptions = [
    {
        label: 'chat:ai.nav.overview',
        value: 'overview',
        subheading: null,
        hideHeader: true
    },
    {
        label: 'chat:ai.nav.sources',
        value: 'sources',
        subheading: 'chat:ai.nav.sourcesSub'
    },
    {
        label: 'chat:ai.nav.articles',
        value: 'articles',
        subheading: 'chat:ai.nav.articlesSub'
    },
    {
        label: 'chat:ai.nav.channels',
        value: 'channels',
        subheading: 'chat:ai.nav.channelsSub'
    },
    {
        label: 'chat:ai.nav.settings',
        value: 'settings',
        subheading: 'chat:ai.nav.settingsSub'
    },
    {
        label: 'chat:ai.nav.history',
        value: 'history',
        subheading: 'chat:ai.nav.historySub'
    },
    {
        label: 'chat:ai.nav.test',
        value: 'test',
        subheading: 'chat:ai.nav.testSub'
    }
]

export const agentRoles = [
    {
        label: 'Agent',
        value: 1,
        subheading: 'Manage and respond to conversations, but not change settings..',
        maxChats: true
    },
    {
        label: 'Admin',
        // Matches API InboxUser.role: 0=admin, 1=agent, 2=viewer
        value: 0,
        subheading: 'Full access to this Inbox, including all settings.',
        maxChats: true
    },
    {
        label: 'Viewer',
        value: 2,
        subheading:
            'Able to view conversations and add notes, but not respond directly to customers or change settings.'
    }
]

/** @param {number} value InboxUser.role (API: 0=Admin, 1=Agent, 2=Viewer). Legacy UI Viewer was 3. */
export function parseAgentRole(value) {
    if (value === 3) return 'Viewer'
    const role = agentRoles.find((t) => t.value === value)

    if (role) return role.label

    return null
}

/**
 * Whether the user may open inbox channel/settings pages.
 * Inbox admins (role 0) always can; Transpond account admins (roleId 1) can as a bypass.
 * @param {number} inboxRole InboxUser.role
 * @param {number} accountRoleId AccountUser roleId
 */
export function canManageInboxSettings(inboxRole, accountRoleId) {
    return inboxRole === 0 || accountRoleId === 1
}

export function guessName(emailAddress) {
    // try and determine the name based on the email address. eg if its not a system name like admin or sales. Check if its got dots in there and infer first and last name from that
    // the reason for this is that capsule needs a first or last name in order to create the contact, at the moment customers have to manually enter the name to do it
    let firstName = '',
        lastName = ''
    let local = emailAddress.split('@')[0].replace(/\d+/g, '').split('+')[0].toLowerCase() // strip numbers as they wont ever be needed
    if (systemEmailNames.indexOf(local) > -1) return { firstName, lastName } // dont do anything if its a system name
    const dotSplit = local.split('.')
    if (dotSplit.length === 2) {
        // assume first and last name
        firstName = dotSplit[0]
        lastName = dotSplit[1]
    } else if (dotSplit.length === 1) {
        // just 1 word so just store that in the first name
        firstName = local
    } else {
        // keep the first word in the first name and store the rest in the last name
        firstName = dotSplit[0]
        lastName = dotSplit.slice(1).join(' ')
    }

    if (firstName) firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1)
    if (lastName) lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1)

    return { firstName, lastName }
}

const systemEmailNames = [
    // General / Administrative
    'admin',
    'administrator',
    'admins',
    'info',
    'information',
    'contact',
    'contacts',
    'office',
    'frontdesk',
    'reception',
    'hello',
    'mail',
    'team',
    'staff',
    'group',
    'support',
    'help',
    'helpdesk',
    'customer',
    'customerservice',
    'service',
    'no-reply',
    'noreply',
    'no.reply',
    'do-not-reply',
    'donotreply',
    'donotreply',
    'auto-reply',
    'autoreply',
    'auto.response',
    'autoresponse',

    // Sales / Marketing
    'sales',
    'salesteam',
    'sales-info',
    'sales.inquiry',
    'marketing',
    'mktg',
    'promos',
    'promo',
    'offers',
    'discounts',
    'advertising',
    'ads',
    'adverts',
    'pr',
    'press',
    'media',
    'outreach',
    'partnership',
    'partnerships',
    'partners',
    'affiliates',
    'affiliate',
    'bizdev',

    // Technical / IT
    'webmaster',
    'postmaster',
    'hostmaster',
    'abuse',
    'security',
    'sysadmin',
    'it',
    'tech',
    'it.support',
    'itsupport',
    'devops',
    'engineering',
    'dns',
    'noc',
    'network',
    'server',
    'root',

    // Finance / HR / Legal
    'accounts',
    'accounting',
    'billing',
    'finance',
    'invoices',
    'invoice',
    'payments',
    'payroll',
    'hr',
    'humanresources',
    'careers',
    'jobs',
    'recruitment',
    'talent',
    'hiring',
    'legal',
    'compliance',
    'contracts',
    'privacy',

    // Operations / Management
    'ceo',
    'cto',
    'cio',
    'cfo',
    'coo',
    'founder',
    'owners',
    'owner',
    'directors',
    'board',
    'management',
    'managers',
    'operations',
    'ops',
    'projects',
    'project',
    'logistics',
    'planning',
    'strategy',

    // Customer Service / Product
    'feedback',
    'survey',
    'bugs',
    'bugreport',
    'product',
    'returns',
    'warranty',
    'support-team',
    'support.team',
    'customer-support',
    'customersuccess',
    'help-team',
    'clientcare',
    'care',
    'qa',

    // System / Automation
    'bounce',
    'mailer-daemon',
    'mailer',
    'auto',
    'robot',
    'bot',
    'updates',
    'notifications',
    'notify',
    'alerts',
    'alert',
    'status',
    'system',
    'daemon',
    'reports',
    'report',
    'scheduler',
    'noreply-bot',
    'emailbot',
    'updater',

    // Misc / Common Variations
    'test',
    'testing',
    'demo',
    'example',
    'sample',
    'newsletter',
    'subscriptions',
    'subscribe',
    'unsubscribe',
    'events',
    'event',
    'news',
    'pressrelease',
    'announcement',
    'announcements',
    'requests',
    'request',
    'forms',
    'formsupport'
]
